<div class="flex flex-col report-issue-dialog">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>

  <form [formGroup]="reportIssueForm" class="overflow-y-auto">
    <div class="flex flex-col">
      <div class="flex-col form-field">
        <div class="flex flex-row mb-10">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.SERVICE' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SOLUTION_DETAILS' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}
            </div> 
            <div>{{report?.service.name}}</div>
          </div>
          <div class="flex flex-row mb-20">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.RELEASE' | transloco}}</div>
            <div class="flex flex-row">{{releaseVersion ? releaseVersion : 'INSTANCE_SUMMARY.NA' | transloco}}
              <div *ngIf="isAMR" class="flex flex-row justify-center items-center amr-text pl-10 ml-10 mt-4"> 
                {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-10">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.BLUEPRINT' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SERVICE_DEFINITION_VERSION_DETAILS' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}</div>
            <div>{{report?.blueprint.name}}</div>
          </div>
          <div class="flex flex-row mb-20">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.VERSION' | transloco}}</div>
            <div>{{version? version : 'INSTANCE_SUMMARY.NA' | transloco}}</div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-10 items-center">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.INSTANCE' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.INSTANCE_DETAILS' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}</div>
            <div>{{report?.instance.name}}</div>
          </div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.ENVIRONMENT' | transloco}}</div>
            <div>{{report?.instance?.environment? report?.instance?.environment : 'INSTANCE_SUMMARY.NA' | transloco}}</div>
          </div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.DATA_ZONE' | transloco}}</div>
            <div>{{report?.instance?.dataZone}}</div>
          </div>
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4 label">{{'INSTANCE_SUMMARY.REPORT_ISSUE.RELEASE_PACKAGE_VERSION' | transloco}}</div>
            <div>{{(report?.instance?.activeConfiguration?.manifest?.version)? report?.instance?.activeConfiguration?.manifest?.version : ('INSTANCE_SUMMARY.NA' | transloco)}}</div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-4">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.ISSUE_DESCRIPTION' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.ISSUE_DETAILS' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <textarea class="pt-12 h-136" formControlName="message" maxlength="300" required>
        </textarea>
        <div class="flex flex-row justify-between">
          <app-error [control]="reportIssueForm.get('message')"></app-error>
          <span class="subtitle-text">{{reportIssueForm.get('message').value.length}}/300</span>
        </div>
      </div>
    </div>
  </form>

  <span class="flex-auto"></span>

  <mat-divider class="mb-32"></mat-divider>

  <ng-container>
    <div class="flex-row" dir="rtl">
      <button class="accent ml-16" type="button" (click)="reportIssue()">{{'BUTTONS.REPORT' | transloco}}</button>
      <button class="white" type="button"
              (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </ng-container>
</div>
